import { root, id } from './posts';

export const posts = {
  ...root,
  id,
};
